module.exports = __webpack_public_path__ + "static/media/exchange.4fa309fe.svg";